import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <main className="max-w-2xl mx-auto px-4 py-12">
      <Link to="/" className="text-white/40 hover:text-white/70 text-sm transition-colors">
        ← Home
      </Link>
      <h1 className="font-display text-4xl text-white mt-4 mb-8">About ProviderPayWatch</h1>

      <div className="space-y-6 text-white/60 leading-relaxed">
        <p>
          ProviderPayWatch is a comprehensive conflict-of-interest and transparency tool that helps organizations, patients, researchers, and journalists
          understand financial relationships between healthcare providers and the pharmaceutical and
          medical device industry — and whether those providers have been flagged for federal exclusions.
        </p>

        <div className="card">
          <h2 className="text-white font-medium mb-3">Payment Data</h2>
          <p className="text-sm mb-2">
            Payment data is sourced from the CMS Open Payments database — a federal program that collects and publishes information about financial relationships
            between pharmaceutical manufacturers, medical device companies, and healthcare providers.
            These disclosures are required under the Physician Payments Sunshine Act (part of the Affordable Care Act).
          </p>
          <p className="text-sm">
            Payment data covers program years 2016 through 2025 and is updated annually by CMS.
            Disclosure of a payment does not imply wrongdoing — receiving payments from industry is
            common and often appropriate, such as for legitimate research or educational speaking.
          </p>
        </div>

        <div className="card">
          <h2 className="text-white font-medium mb-3">Federal Exclusion Data</h2>
          <p className="text-sm mb-2">
            ProviderPayWatch checks providers against two federal exclusion databases:
          </p>
          <ul className="text-sm space-y-2">
            <li>
              <span className="text-red-400 font-medium">OIG LEIE</span> — The HHS Office of Inspector
              General's List of Excluded Individuals and Entities. Providers on this list are excluded
              from participating in Medicare, Medicaid, and other federal healthcare programs. Updated monthly.
            </li>
            <li>
              <span className="text-orange-400 font-medium">SAM.gov</span> — The System for Award
              Management exclusions database, which covers parties excluded from federal contracts,
              grants, and programs across all federal agencies. Updated daily.
            </li>
          </ul>
          <p className="text-sm mt-2">
            When a provider's NPI matches an exclusion record, a confirmed flag is shown. When only
            a name and state match is found, a "possible match" warning is displayed — users should
            verify directly with the source before drawing conclusions.
          </p>
          <p className="text-sm mt-2">
            Some SAM.gov records may contain data from Dun &amp; Bradstreet.
          </p>          
        </div>

        <div className="card">
          <h2 className="text-white font-medium mb-3">Disclaimer</h2>
          <p className="text-sm">
            ProviderPayWatch is not affiliated with CMS, HHS, or the federal government.
            Information is provided for transparency and educational purposes only.
            Presence of a payment record does not imply wrongdoing. Exclusion flags should
            be independently verified with the relevant federal agency before any action is taken.
            ProviderPayWatch is currently in beta — if you notice any data issues please contact us.
          </p>
        </div>

        <p className="text-white/30 text-xs text-center">
          ProviderPayWatch · Built with CMS Open Payments, HHS OIG LEIE, and SAM.gov data
        </p>
      </div>
    </main>
  );
}